<template>
  <div class="create-comment-gift-done">
    <p class="create-comment-gift-done__text">
      {{ texts.giftDoneText }}
    </p>

    <div class="create-comment-gift-done__actions">
      <a class="btn cta" :href="guestLink">
        {{ texts.giftCertificateLink }}
      </a>

      <button class="btn outline" type="button" @click="toggleModal()">
        {{ texts.close }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from "vuex";

  export default {
    computed: {
      ...mapState("donations", ["guestLink"]),
    },

    data() {
      return {
        texts: lavendlaObituary.createComment,
      };
    },

    methods: {
      ...mapActions("createComment", ["toggleModal"]),
    },
    name: "CreateCommentGiftDone",
  };
</script>
